<template>
   <v-btn class="back" icon @click.prevent="back()">
      <v-icon>keyboard_backspace</v-icon>
   </v-btn>
</template>
<script>
export default {
    methods : {
      back(){
        window.location.href = 'https://jujue.app';
      }
    }
}
</script>
<style scoped>
 .back {
    float:left;
 }
</style>

